module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "black-back"
  }, [(_vm.pageloading) ? _c('div', {
    staticClass: "dexame-loading-mask"
  }, [_c('van-loading', {
    attrs: {
      "size": "24px",
      "color": "#fff",
      "vertical": ""
    }
  }, [_vm._v("加载中...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "score-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-title"
  }, [_vm._v(_vm._s(_vm.startRow.saiqu_name) + " " + _vm._s(_vm.startRow.title))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child"
  }, [_vm._v(_vm._s(_vm.currentSubject.subject_name))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child"
  }, [_vm._v(_vm._s(_vm.currentSubject.mingcheng))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child dexame-caipan-line"
  }, [(_vm.caipan_index >= 1000) ? [_vm._v("高级裁判")] : [_vm._v("裁判")], _vm._v("\n      " + _vm._s(_vm.caipan_index) + "：" + _vm._s(_vm.caipan.name || '') + "\n    ")], 2)]), _vm._v(" "), (_vm.caipan_index == 1000) ? _c('div', {
    staticClass: "score-content dexame-video-wrap"
  }, [(_vm.videoPlayUrl) ? _c('video', {
    attrs: {
      "width": "100%",
      "height": "180px",
      "src": _vm.videoPlayUrl,
      "controls": ""
    }
  }) : _c('van-notice-bar', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "text": "视频未上传"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "score-content dexame-fields-wrap"
  }, [_c('div', {
    staticClass: "dexame-total-bar"
  }, [_c('span', [_vm._v("总分：" + _vm._s(_vm.scoreTotalDisplay))]), _vm._v(" "), (_vm.scoreFixIcon === 'add') ? _c('span', {
    staticClass: "fix-up"
  }, [_c('van-icon', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "name": "play",
      "color": "#ff0000"
    }
  })], 1) : (_vm.scoreFixIcon === 'pen') ? _c('span', {
    staticClass: "fix-down"
  }, [_c('van-icon', {
    staticStyle: {
      "transform": "rotate(90deg)"
    },
    attrs: {
      "name": "play",
      "color": "#0dac0d"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.scoreForm.subject_scoreFieldsMap || _vm.scoreForm.subject_scoreFieldsMap.length === 0) ? _c('div', {
    staticClass: "dexame-empty-fields"
  }, [(_vm.formLoadDone) ? _c('van-empty', {
    attrs: {
      "description": "评分表暂未配置或加载失败"
    }
  }) : _vm._e()], 1) : _c('van-cell-group', {
    staticClass: "dexame-cell-group",
    attrs: {
      "title": "评分项"
    }
  }, _vm._l((_vm.scoreForm.subject_scoreFieldsMap), function(field) {
    return _c('div', {
      key: field.name,
      staticClass: "dexame-score-item"
    }, [_c('div', {
      staticClass: "dexame-field-name"
    }, [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('div', {
      staticClass: "dexame-max-hint"
    }, [_vm._v("最高 " + _vm._s(_vm.fieldMax(field)) + " 分")]), _vm._v(" "), _c('div', {
      staticClass: "dexame-stepper-row"
    }, [_c('van-stepper', {
      staticClass: "dexame-stepper",
      attrs: {
        "min": 0,
        "max": _vm.fieldMax(field),
        "step": 0.5,
        "disabled": !_vm.canEditScores
      },
      model: {
        value: (_vm.scoreForm[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.scoreForm, field.name, $$v)
        },
        expression: "scoreForm[field.name]"
      }
    })], 1), _vm._v(" "), _c('van-slider', {
      staticClass: "dexame-field-slider",
      attrs: {
        "min": 0,
        "max": _vm.fieldMax(field),
        "step": 0.5,
        "bar-height": "6px",
        "disabled": !_vm.canEditScores,
        "active-color": "#1989fa"
      },
      model: {
        value: (_vm.scoreForm[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.scoreForm, field.name, $$v)
        },
        expression: "scoreForm[field.name]"
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dexame-submit-wrap"
  }, [_c('van-button', {
    attrs: {
      "type": "info",
      "block": "",
      "round": "",
      "loading": _vm.saveLoading,
      "disabled": !_vm.canEditScores
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n        提交评分（" + _vm._s(_vm.scoreTotalDisplay) + "）\n      ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.goPre
    }
  }, [_vm._v("上一队")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.showList
    }
  }, [_vm._v("全部队伍 " + _vm._s(_vm.current_index + 1) + "/" + _vm._s(_vm.list.length))]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("下一队")])], 1), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "90%",
      "height": "80%"
    },
    model: {
      value: (_vm.listShow),
      callback: function($$v) {
        _vm.listShow = $$v
      },
      expression: "listShow"
    }
  }, [_c('div', {
    staticClass: "dexame-list-popup-inner"
  }, [_c('van-cell-group', _vm._l((_vm.list), function(item, iindex) {
    return _c('van-cell', {
      key: item.id,
      attrs: {
        "center": "",
        "is-link": "",
        "icon": iindex === _vm.current_index ? 'success' : '',
        "label": item.mingcheng
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(item, iindex)
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "flex-align"
    }, [_c('span', {
      staticClass: "font-size3 bold",
      class: Number(item.score) > 0 ? 'ok' : ''
    }, [_vm._v(_vm._s(iindex + 1) + "# " + _vm._s(item.subject_name))])])])], 2)
  }), 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-logo"
  }, [_c('div', {
    staticClass: "score-logo-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/logo2.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e60b6bba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/dexame/DexameScore.vue
// module id = 2616
// module chunks = 0